import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class DeepCloneService {
  /**
   * Clones a value using lodash-es/cloneDeep
   * @param value The value to clone
   * @returns A deep clone of the value
   */
  static clone<T>(value: T): any {
    return cloneDeep(value);
  }
}
